import appConfig from '@/common/appConfig';
import { trackMemorySnapshot } from '@/common/store/pinia/telemetry/modules/performance';
import { initializeTTITracking, cleanupTTITracking } from '@/common/store/pinia/telemetry/modules/tti';
import {
  initializeClickDelayTracking,
  cleanupClickDelayTracking
} from '@/common/store/pinia/telemetry/modules/ui';
import {
  initializeScrollFpsTracking,
  cleanupScrollFpsTracking,
  cleanupFpsTracking
} from '@/common/store/pinia/telemetry/modules/fps';

export const initializeMonitors = (): void => {
  trackMemorySnapshot({ trigger: 'telemetry_initialized' });
  initializeTTITracking();
  initializeClickDelayTracking();
  initializeScrollFpsTracking();
};

export const cleanupMonitors = (): void => {
  cleanupTTITracking();
  cleanupClickDelayTracking();
  cleanupScrollFpsTracking();
  cleanupFpsTracking();
};

export type PostHogBaseConfig = {
  api_host: string;
  debug: boolean;
  capture_pageview: boolean;
  advanced_disable_flags: boolean;
  capture_performance: boolean;
  disable_compression: boolean;
  autocapture: boolean;
  capture_exceptions: {
    capture_unhandled_errors: boolean;
    capture_unhandled_rejections: boolean;
    capture_console_errors: boolean;
  };
  disable_persistence: boolean;
  disable_session_recording: boolean;
};

export const getPostHogBaseConfig = (): PostHogBaseConfig | null => {
  if (!appConfig.telemetry?.apiKey || !appConfig.telemetry?.host) {
    return null;
  }

  return {
    api_host: appConfig.telemetry.host,
    debug: appConfig.telemetry.debug ?? false,
    capture_pageview: false,
    advanced_disable_flags: true,
    capture_performance: true,
    disable_compression: appConfig.telemetry.debug ?? false,
    autocapture: true,
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: true
    },
    disable_persistence: true,
    disable_session_recording: true
  };
};

export const getTelemetryApiKey = (): string | undefined => appConfig.telemetry?.apiKey;
